import { useState } from "react";
import { newArrivals } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const filters = ["全部", "现货", "预售", "限量"] as const;

const statusStyle: Record<string, string> = {
  现货: "bg-accent-100 text-accent-800",
  预售: "bg-primary-100 text-primary-800",
  预订: "bg-secondary-200 text-secondary-900",
  限量: "bg-foreground-950 text-background-50",
};

export default function NewArrivals() {
  const [active, setActive] = useState<(typeof filters)[number]>("全部");

  const list = newArrivals.filter((item) => {
    if (active === "全部") return true;
    if (active === "预售") return item.status === "预售" || item.status === "预订";
    return item.status === active;
  });

  return (
    <section id="new-arrivals" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="新品速递"
          title="每日更新的预售与现货情报"
          desc="一条条短讯实时同步，抢购、补货、延期都能第一时间看到。"
          actionLabel="查看全部新品"
          actionHref="#database"
        />

        <div className="mb-5 flex flex-wrap items-center gap-3">
          <div className="flex rounded-full border border-background-300 bg-background-50 px-1 py-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === f
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-700"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
          <span className="text-xs text-foreground-500">
            共 {list.length} 条 · 更新于今日 09:40
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${statusStyle[item.status]}`}>
                  {item.status}
                </span>
                <span className="flex items-center gap-1 text-[11px] text-foreground-400">
                  <i className="ri-calendar-line" />
                  {item.date}
                </span>
              </div>

              <h3 className="mt-3 font-heading text-sm font-bold leading-snug text-foreground-950">
                {item.title}
              </h3>

              <div className="mt-2 flex flex-wrap items-center gap-1.5 text-[11px] text-foreground-500">
                <span className="rounded bg-background-100 px-1.5 py-0.5">{item.brand}</span>
                <span className="rounded bg-background-100 px-1.5 py-0.5">{item.series}</span>
                <span className="rounded bg-background-100 px-1.5 py-0.5">{item.scale}</span>
              </div>

              <div className="mt-auto pt-4">
                <div className="flex items-end justify-between">
                  <span className="font-heading text-lg font-bold text-primary-600">{item.price}</span>
                  <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                    <i className="ri-fire-line text-primary-500" />
                    热度 {item.heat}
                  </span>
                </div>
                <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-primary-500"
                    style={{ width: `${item.heat}%` }}
                  />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}